import api from './axiosInstance';
import i18n from '../i18n';

export const getCustomerIds = async (userId) => {
    try {
        return await api.post(`/google/getCustomerIds`, { userId });
    } catch (error) {
        console.error('Error fetching google customer IDs data:', error);
        throw new Error(i18n.t('googleService.load_google_data_error'));
    }
};

export const getCampaigns = async (userId, login_customer_id, customer_id) => {
    try {
        return await api.get(`/google/${userId}/loginCustomerId/${login_customer_id}/getCampaigns/${customer_id}`);
    } catch (error) {
        console.error('Error fetching google campaigns for customerId:', error);
        throw new Error(i18n.t('googleService.load_google_data_error'));
    }
};

export const getUserData = async (userId, customerId) => {
    try {
        return await api.get(`/google/${userId}/getCustomerData/${customerId}`);
    } catch (error) {
        console.error('Error fetching google user data for customerId:', error);
        throw new Error(i18n.t('googleService.load_google_data_error'));
    }
};

export const createCampaign = async (userId, login_customer_id, customer_id, campaignData) => {
    try {
        return await api.post(`/google/${userId}/loginCustomerId/${login_customer_id}/createCampaign/${customer_id}`, {
            campaignData
        });
    } catch (error) {
        console.error('Error creating google campaign for customerId:', error);
        throw new Error(i18n.t('googleService.create_campaign_error'));
    }
};

export const updateCampaign = async (userId, login_customer_id, customer_id, campaignData) => {
    try {
        return await api.post(`/google/${userId}/loginCustomerId/${login_customer_id}/updateCampaign/${customer_id}`, {
            campaignData
        });
    } catch (error) {
        console.error('Error editing google campaign for customerId:', error);
        throw new Error(i18n.t('googleService.update_campaign_error'));
    }
};

export const deleteCampaign = async (userId, login_customer_id, customer_id, campaignData) => {
    try {
        return await api.post(`/google/${userId}/loginCustomerId/${login_customer_id}/deleteCampaign/${customer_id}`, {
            campaignData
        });
    } catch (error) {
        console.error('Error deleting google campaign for customerId:', error);
        throw new Error(i18n.t('googleService.delete_campaign_error'));
    }
};

export const getConversionActions = async (userId, login_customer_id, customer_id) => {
    try {
        return await api.get(`/google/${userId}/loginCustomerId/${login_customer_id}/listConversionActions/${customer_id}`);
    } catch (error) {
        console.error('Error fetching conversion actions for customerId:', error);
        throw new Error(i18n.t('googleService.load_conversion_actions_error'));
    }
};

export const getAllConversionActions = async (userId) => {
    try {
        return await api.get(`/google/${userId}/getAllConversionActions`);
    } catch (error) {
        console.error('Error fetching all conversion actions for customerId:', error);
        throw new Error(i18n.t('googleService.load_conversion_actions_error'));
    }
};

export const updateConversionAction = async (userId, login_customer_id, customer_id, name, resource_name) => {
    try {
        return await api.post(`/google/${userId}/loginCustomerId/${login_customer_id}/updateConversionAction/${customer_id}`, {
            name,
            resource_name
        });
    } catch (error) {
        console.error('Error updating conversion action for customerId:', error);
        throw new Error(i18n.t('googleService.update_conversion_action_error'));
    }
};

export const createConversionAction = async (userId, login_customer_id, customer_id, name) => {
    try {
        return await api.post(`/google/${userId}/loginCustomerId/${login_customer_id}/createConversionAction/${customer_id}`, {
            name
        });
    } catch (error) {
        console.error('Error creating conversion action for customerId:', error);
        throw new Error(i18n.t('googleService.create_conversion_action_error'));
    }
};

export const deleteConversionAction = async (userId, login_customer_id, customer_id, resource_name) => {
    try {
        return await api.post(`/google/${userId}/loginCustomerId/${login_customer_id}/deleteConversionAction/${customer_id}`, {
            resource_name
        });
    } catch (error) {
        console.error('Error deleting google conversion action for customerId:', error);
        throw new Error(i18n.t('googleService.delete_conversion_action_error'));
    }
};